import { render, staticRenderFns } from "./AddWidgetDialog.vue?vue&type=template&id=06331dd7"
import script from "./AddWidgetDialog.vue?vue&type=script&lang=js"
export * from "./AddWidgetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports